import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';
import { ConversationMessageKey } from 'flow/types/TicketEventData';
import { isTypeExtensionKey } from 'flow/utils/extension-utils-TW';
import { selectVisitorContact } from 'flow/selectors/TicketsSelectors';
import {
    selectEventDirection,
    selectEventSender,
    selectEventSenderType,
} from 'flow/selectors/TicketEventSelectors';
import TicketAvatar from 'flow/components/tickets/TicketAvatar';
import { AvatarSize } from 'flow/components/ui-components/ChatAvatar';

interface Props {
    ticketKey: TicketKey;
    messageKey: ConversationMessageKey;
    size?: AvatarSize;
}

const SenderAvatarExternalService = ({
    ticketKey,
    messageKey,
    size,
}: Props) => {
    const sender = useAppSelector((state) =>
        selectEventSender(state, ticketKey, messageKey),
    );
    const senderType = useAppSelector((state) =>
        selectEventSenderType(state, ticketKey, messageKey),
    );
    const direction = useAppSelector((state) =>
        selectEventDirection(state, ticketKey, messageKey),
    );
    const contact = useAppSelector((state) =>
        direction === 'INCOMING'
            ? selectVisitorContact(state, ticketKey)
            : undefined,
    );

    return (
        <TicketAvatar
            extensionKey={isTypeExtensionKey(sender) ? sender : undefined}
            senderType={senderType}
            contact={contact}
            ignoreAvatarResource={
                direction === 'INCOMING' &&
                (isTypeExtensionKey(sender) || contact?.get('type') === 'bound')
            }
            size={size}
        />
    );
};

export default SenderAvatarExternalService;
